import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { PatternProduct } from '@/shared/composables/patternProducts/patternProducts.types';

// Store created in preparation to be used in the within the pattern products tab
export const usePatternProductsStore = defineStore('pattern-products', () => {
  const patternProducts = ref<PatternProduct[]>([]);

  const validPatternProducts = computed<PatternProduct[]>(() =>
    patternProducts.value.filter(isValidPatternProduct)
  );

  const isValidPatternProduct = (pp: PatternProduct) =>
    pp.product_id && pp.variant_id;

  const initialize = (initialPatternProducts: PatternProduct[]) => {
    patternProducts.value = [...initialPatternProducts];
  };

  return {
    validPatternProducts,
    initialize
  };
});
